import { useComponentModal } from 'src/hook/modal/useComponentModal';
import usePopUp from 'src/hook/modal/usePopUp';
import { Question } from 'src/model/Scenario';
import { IconLocation, ScenariosLocation } from 'src/utils/URLUtils';
import styles from './ImageSection.module.scss';
interface Props {
    question: Question;
}

const ImageSection = ({ question }: Props) => {
    const { startClosing } = useComponentModal();
    const { showClosePopUp } = usePopUp();

    const handleClose = () => {
        startClosing();
    };

    return (
        <div className={styles.imageSection}>
            <div style={{ backgroundImage: `url(${ScenariosLocation(`${question.r}`)})` }}
                className={styles.questionImage} />
            <span
                className={styles.close} onClick={() => showClosePopUp(handleClose)}>
                <img src={IconLocation('x')} alt="close" />
            </span>
        </div>

    );
};

export default ImageSection;
